module.exports = __webpack_public_path__ + "img/loading_papper_4.514a6dbb.png";